import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class A11YFormatService {
  public dateToA11yString(date: Date | string, format: string): string {
    const dateAsDate = typeof date === 'string' ? new Date(date) : date;
    return dateAsDate
      ? format
          .replace('d', this.getDay(dateAsDate))
          .replace('m', this.getMonth(dateAsDate))
          .replace('Y', this.getFullyear(dateAsDate))
          .replace('y', this.getShortYear(dateAsDate))
      : '';
  }

  public numberToA11yString(number: number | string): string {
    const numSpl = `${number}`.split('.');
    return numSpl.length > 1 ? `${numSpl[0]},${numSpl[1].split('').join(' ')}` : number.toString();
  }

  private getDay(date: Date): string {
    const days = [
      'erster',
      'zweiter',
      'dritter',
      'vierter',
      'fünfter',
      'sechster',
      'siebenter',
      'achter',
      'neunter',
      'zehnter',
      'elfter',
      'zwölfter',
      'dreizehnter',
      'vierzehnter',
      'fünfzehnter',
      'sechszehnter',
      'siebzehnter',
      'achzehnter',
      'neunzehnter',
      'zwanzigster',
      'einundzwanzigster',
      'zweiundzwanzigster',
      'dreiundzwanzigster',
      'vierundzwanzigster',
      'fünfundzwanzigster',
      'sechsundzwanzigster',
      'siebenundzwanzigster',
      'achtundzwanzigster',
      'neunundzwanzigster',
      'dreißigster',
      'einunddreißigster',
    ];

    return days[date.getDate() - 1];
  }

  private getMonth(date: Date): string {
    const month = [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ];
    return month[date.getMonth()];
  }

  private getFullyear(date: Date): string {
    return date.getFullYear().toString();
  }

  private getShortYear(date: Date): string {
    return date.getFullYear().toString().substring(2, 2);
  }
}
